import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Typography } from '@mui/material';
import BottomSheetOrDialog from '../../components/BottomSheetOrDialog/BottomSheetOrDialog';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import { whatsappUs } from '../../utils/whatsapp';

const ContactUsDialog = props => {
  const { intl, open, onClose, feature } = props;

  return (
    <BottomSheetOrDialog
      open={open}
      onClose={onClose}
      header={intl.formatMessage({ id: `unlock-${feature}-title` })}
      content={
        <>
          <VideoPlayer url="https://youtu.be/iC57Lcf6y4g" />
          <Typography style={{ whiteSpace: 'pre-wrap', fontSize: 15, lineHeight: '2em' }}>
            {intl.formatMessage({ id: `unlock-${feature}-description` })}
          </Typography>
        </>
      }
      actions={[
        <Button onClick={onClose}>{intl.formatMessage({ id: 'maybe-later' })}</Button>,
        <Button
          onClick={() => whatsappUs({ text: '(APP) 想解鎖醫保對沖計算機, 想了解加購詳情及安排教學😊' })}
          color="primary"
        >
          {intl.formatMessage({ id: 'unlock-now' })}
        </Button>
      ]}
      BottomSheetProps={{
        expandOnContentDrag: false,
        disableAutoDismiss: true
      }}
      BottomSheetParams={{
        hideCloseButton: true,
        headerStyle: { fontSize: 15 }
      }}
      DialogProps={{
        maxWidth: 'xs',
        fullWidth: true
      }}
      DialogActionsProps={{
        style: { padding: 4 }
      }}
      DialogParams={{
        hideCloseButton: true,
        headerStyle: { fontSize: 15 }
      }}
    />
  );
};

export default injectIntl(ContactUsDialog);
